import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","text-align":"center","margin-bottom":"20px"} }, "注意：与收付款有关的合同的相对方需在金蝶或ERP有相应的供应商或客户信息！", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("同步ERP数据")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("附加信息")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("转账银行信息")
const _hoisted_6 = { style: {"text-align":"right"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 保 存 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { nextTick, reactive, ref, unref } from 'vue';
import { ElForm, ElMessage, FormRules } from 'element-plus';
import { useCurrency } from '@/store/currency.store';
import { CpDetailApi, CreatePartybApi, EditorPartybApi, GetErpSupplierApi, GetErpCustomApi } from '@/apis/counterpart/counterpart.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {

const cnyStore = useCurrency();


const elFormRef = ref<InstanceType<typeof ElForm>>();

const formSchema = ref<any>({});
const state = reactive({
	show: false,
	loading: false,
	active: 'basic',
	title: '相对方(乙方)编辑器',
	rules: {
		part_type_id: [{ required: true, message: '相对方类型必填', trigger: ['blur', 'change'] }],
		no: [{ required: true, message: '相对方编号不能留空', trigger: 'blur' }],
		name: [{ required: true, message: '相对方名称不能留空', trigger: 'blur' }],
		// nation: [{ required: true, message: '国家不能为空', trigger: 'blur' }],
		bank_account: [{ required: true, message: '银行账户不能为空', trigger: 'blur' }],
		bank_name: [{ required: true, message: '账户名称不能为空', trigger: 'blur' }],
		bank: [{ required: true, message: '开户银行不能为空', trigger: 'blur' }],
		currency: [{ required: true, message: '请选择币种', trigger: 'blur' }],
	} as FormRules,
	cansave: false,
});

const load = {
	getPartyBInfo: (rowId: any) => {
		state.loading = true;
		const onSuccess = (res: any) => {
			const { succeeded, errors, data } = res;
			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				formSchema.value = Object.assign({}, data);
			}
		};

		const onFail = (err: any) => {
			ElMessage.error(err.message);
		};

		const onFinally = () => {
			state.loading = false;
		};

		CpDetailApi(rowId).then(onSuccess).catch(onFail).finally(onFinally);
	},
};

const actions = {
	/* 同步ERP数据 */
	erpasync: () => {
		const formData = unref(formSchema);

		if (!formData.no) {
			ElMessage.warning('供应商/客户编号未填写');
			return;
		}

		state.loading = true;

		const onFail = (err: any) => {
			ElMessage.error(err.message);
		};

		const onFinally = () => {
			state.loading = false;
		};

		/* 供应商 */
		if (formData.part_type_id == '2') {
			const onSuccess = (res: any) => {
				const { succeeded, errors, data } = res;
				if (!succeeded) {
					state.cansave=false;
					ElMessage.error(errors);
				} else {
					const supplier = data || undefined;
					if (!supplier) {
						state.cansave=false;
						ElMessage.warning(`找不到编号为：${formData.no}的供应商数据。`);
					} else {
						/* 如果ERP没有相关数据，则不更新到合同系统相对方信息 */
						const dataKeys = Object.keys(data);
						dataKeys.forEach((ky: any) => {
							formSchema.value[ky] = null;
							if (data[ky]) {
								formSchema.value[ky] = data[ky];
							}
						});
						state.cansave=true;
					}
				}
			};
			GetErpSupplierApi(formData.no).then(onSuccess).catch(onFail).finally(onFinally);
		}

		/* 客户 */
		if (formData.part_type_id == '3') {
			const onSuccess = (res: any) => {
				const { succeeded, errors, data } = res;
				if (!succeeded) {
					state.cansave=false;
					ElMessage.error(errors);
				} else {
					const customs = data || undefined;
					if (!customs) {
						state.cansave=false;
						ElMessage.warning(`找不到编号为：${formData.no}的客户数据。`);
					} else {
						/* 如果ERP没有相关数据，则不更新到合同系统相对方信息 */
						const dataKeys = Object.keys(data);
						dataKeys.forEach((ky: any) => {
							formSchema.value[ky] = null;
							if (data[ky]) {
								formSchema.value[ky] = data[ky];
							}
						});
						state.cansave=true;
					}
				}
			};
			
			GetErpCustomApi(formData.no).then(onSuccess).catch(onFail).finally(onFinally);
		}
		state.loading = false;
	},
	save: () => {
		unref(elFormRef)?.validate((valid: boolean) => {
			if (!valid) return;

			const submitData = unref(formSchema);
			state.loading = true;

			const onSuccess = (res: any) => {
				const { succeeded, errors } = res;
				if (!succeeded) {
					ElMessage.error(errors);
				} else {
					ElMessage.success('操作成功');
					$emits('refresh');
					state.show = false;
				}
			};

			const onFail = (err: any) => {
				ElMessage.error(err.message);
			};

			const onFinally = () => {
				state.loading = false;
			};

			const apis = submitData.id ? EditorPartybApi : CreatePartybApi;
			apis(submitData).then(onSuccess).catch(onFail).finally(onFinally);
		});
	},
};

const expFuncs = {
	openDialog: (row?: any) => {
		const rowId = row && row.id ? row.id : '';

		if (rowId) {
			load.getPartyBInfo(rowId);
			state.title = '编辑相对方(乙方)';
		} else {
			formSchema.value = Object.assign({}, { id: '', part_type_id: '', is_enabled: 'Y' });
			state.title = '新增相对方(乙方)';
		}

		nextTick(() => {
			unref(elFormRef)?.clearValidate();
		});

		state.active = 'basic';
		state.show = true;
	},
};

expose({ ...expFuncs });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _unref(state).title,
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(state).show) = $event)),
    width: "900"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          disabled: ['2', '3'].indexOf(`${formSchema.value.part_type_id}`)>=0 && !_unref(state).cansave || _unref(state).loading,
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          disabled: _unref(state).loading,
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_unref(state).show = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_scrollbar, { height: "600px" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_unref(ElForm), {
              ref_key: "elFormRef",
              ref: elFormRef,
              size: "small",
              model: formSchema.value,
              "label-width": "120px",
              rules: _unref(state).rules,
              style: {"padding":"0px 20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "相对方类型",
                          prop: "part_type_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.part_type_id,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.part_type_id) = $event)),
                              placeholder: "请选择相对方类型"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "内部单位",
                                  value: "1"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "供应商",
                                  value: "2"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "客户",
                                  value: "3"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "合作伙伴",
                                  value: "4"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "其他",
                                  value: "99"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "相对方编号",
                          prop: "no"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.no,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.no) = $event)),
                              placeholder: "请输入相对方编号",
                              onBlur: actions.erpasync
                            }, _createSlots({ _: 2 }, [
                              (['2', '3'].indexOf(`${formSchema.value.part_type_id}`) >= 0)
                                ? {
                                    name: "append",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        onClick: actions.erpasync
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ])
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "onBlur"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "名称",
                          prop: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.name) = $event)),
                              placeholder: "请输入相对方名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "简称",
                          prop: "short_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.short_name,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.short_name) = $event)),
                              placeholder: "请输入相对方简称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "法人姓名",
                          prop: "contract"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.contract,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.contract) = $event)),
                              placeholder: "请输入联系人"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "法人联系方式",
                          prop: "contract_num"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.contract_num,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.contract_num) = $event)),
                              placeholder: "请输入联系人电话"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "统一社会信用代码",
                          prop: "code"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.code,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.code) = $event)),
                              placeholder: "请输入统一社会信用代码"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "纳税人资质" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formSchema.value.pay_taxes,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.pay_taxes) = $event)),
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "增值税一般纳税人",
                                  value: "1"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "备注" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              modelValue: formSchema.value.remark,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.remark) = $event)),
                              rows: "2",
                              "show-word-limit": "",
                              maxlength: "150"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "启用状态",
                          prop: "is_enabled"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.is_enabled,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "启用",
                                  value: "Y"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "停用",
                                  value: "N"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, { "content-position": "left" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "国家",
                          prop: "country"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.country,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.country) = $event)),
                              placeholder: "请输入国籍"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "省份/州",
                          prop: "country"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.province,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.province) = $event)),
                              placeholder: "请输入地区"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "地址",
                          prop: "address"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.address,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.address) = $event)),
                              rows: "1",
                              "show-word-limit": "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "发票抬头" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.invoice_title,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formSchema.value.invoice_title) = $event)),
                              placeholder: "请录入发票抬头"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "开票地址" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.invoice_address,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formSchema.value.invoice_address) = $event)),
                              placeholder: "请录入开票地址"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "经营范围" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              modelValue: formSchema.value.business_scope,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formSchema.value.business_scope) = $event)),
                              rows: "5",
                              "show-word-limit": "",
                              maxlength: "500"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, { "content-position": "left" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "国家/地区",
                          prop: "nation"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.nation,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formSchema.value.nation) = $event)),
                              placeholder: "请录入国家"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "币种",
                          prop: "currency"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w100",
                              modelValue: formSchema.value.currency,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formSchema.value.currency) = $event)),
                              filterable: "",
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cnyStore).getSelectList(), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 256))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "银行账户",
                          prop: "bank_account"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.bank_account,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formSchema.value.bank_account) = $event)),
                              placeholder: "请录入银行账户"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "账户名称",
                          prop: "bank_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.bank_name,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formSchema.value.bank_name) = $event)),
                              placeholder: "请录入账户名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "开户银行",
                          prop: "bank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.bank,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formSchema.value.bank) = $event)),
                              placeholder: "请录入开户银行"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "联行号" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.bank_code,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formSchema.value.bank_code) = $event)),
                              placeholder: "请录入开户银行"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "开户银行地址",
                          prop: "bank_address"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: formSchema.value.bank_address,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formSchema.value.bank_address) = $event)),
                              "show-word-limit": "",
                              maxlength: "100"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})